import { render, staticRenderFns } from "./MktAutorizeModel.vue?vue&type=template&id=0fed22ad&"
import script from "./MktAutorizeModel.vue?vue&type=script&lang=js&"
export * from "./MktAutorizeModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports